import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const slides = [{
  image: 'https://cdn.magicpatterns.com/uploads/jUvoSJJQDuppcfj6iYmh3v/diverse-models-showcase-vibrant-fashion-on-the-runway-photo.jpg',
  title: 'The Heritage Line',
  subtitle: 'New Collection'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/vChsCpL21AZ78UvwSRoejp/red_--model.jpg',
  title: 'Bespoke Elegance',
  subtitle: 'Couture Series'
}];
export function Hero() {
  const [current, setCurrent] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent(prev => (prev + 1) % slides.length);
    }, 6000);
    return () => clearInterval(timer);
  }, []);
  const next = () => setCurrent(prev => (prev + 1) % slides.length);
  const prev = () => setCurrent(prev => prev === 0 ? slides.length - 1 : prev - 1);
  return <section className="relative h-[90vh] w-full overflow-hidden bg-black" data-id="element-221">
      <AnimatePresence mode="wait" data-id="element-222">
        <motion.div key={current} initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 1.5,
        ease: 'easeInOut'
      }} className="absolute inset-0" data-id="element-223">
          <img src={slides[current].image} alt={slides[current].title} className="w-full h-full object-cover opacity-70" data-id="element-224" />
          <div className="absolute inset-0 video-overlay" data-id="element-225" />
        </motion.div>
      </AnimatePresence>

      <div className="relative h-full flex flex-col items-center justify-center text-white px-6 text-center" data-id="element-226">
        <AnimatePresence mode="wait" data-id="element-227">
          <motion.div key={current} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -20
        }} transition={{
          duration: 0.8
        }} data-id="element-228">
            <span className="text-[10px] font-display uppercase tracking-[0.5em] mb-4 block" data-id="element-229">
              {slides[current].subtitle}
            </span>
            <h2 className="text-4xl md:text-7xl font-display font-bold mb-8 tracking-[0.2em]" data-id="element-230">
              {slides[current].title}
            </h2>
            <Link to="/lookbook" className="inline-block border border-white px-10 py-4 text-[10px] font-display uppercase tracking-widest hover:bg-white hover:text-black transition-all duration-500" data-id="element-231">
              Explore Lookbook
            </Link>
          </motion.div>
        </AnimatePresence>
      </div>

      {/* Navigation Controls */}
      <div className="absolute inset-x-6 top-1/2 -translate-y-1/2 flex justify-between pointer-events-none" data-id="element-232">
        <button onClick={prev} className="pointer-events-auto p-2 text-white/50 hover:text-white transition-colors" data-id="element-233">
          <ChevronLeftIcon className="w-8 h-8 stroke-[1px]" data-id="element-234" />
        </button>
        <button onClick={next} className="pointer-events-auto p-2 text-white/50 hover:text-white transition-colors" data-id="element-235">
          <ChevronRightIcon className="w-8 h-8 stroke-[1px]" data-id="element-236" />
        </button>
      </div>

      {/* Pagination Dots */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex space-x-4" data-id="element-237">
        {slides.map((_, idx) => <button key={idx} onClick={() => setCurrent(idx)} className={`w-12 h-[1px] transition-all duration-500 ${idx === current ? 'bg-white' : 'bg-white/20'}`} data-id="element-238" />)}
      </div>
    </section>;
}